import { Getter } from 'vuex'
import { RootState } from '@/store/types'
import { PodcastState } from '../types'

const podcastName: Getter<PodcastState, RootState> = (state) => {
  return state.activePodcast?.name || ''
}

export default podcastName
